import PartnerFormPage from "./PartnerFormPage"

const PartnerCreate = () => {
  return (
    <PartnerFormPage></PartnerFormPage>
  )
}

export default PartnerCreate;
